import React from 'react';
import { Select, Typography, InputNumber,TimePicker } from 'antd';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styles from '../SimpleCondition.module.less';
import moment from 'moment';

const format = 'HH:mm';
const { Option } = Select;
const { Paragraph } = Typography;

function ThresholdInputValue(props) {

  const { params, onChangeOrCondition, orCondition } = props;
  const isEditDefault = useSelector(({ alarms }) => alarms.isEditDefault);
  const { t } = useTranslation();
  const ExpRegSoloNumeros="^[0-9]+$";
  const { type } = orCondition;
 
  return (
    <>
      <Select
        value={params.operator}
        onSelect={(value) => onChangeOrCondition('operator', value)}
        disabled={isEditDefault}
      >
        <Option value=">">{t('views.dynamic_alarms_create_edit.type_alarm_options.graterThan')}</Option>
        <Option value="<">{t('views.dynamic_alarms_create_edit.type_alarm_options.lessThan')}</Option>
        <Option value=">=">{t('views.dynamic_alarms_create_edit.type_alarm_options.graterequalThan')}</Option>
        <Option value="<=">{t('views.dynamic_alarms_create_edit.type_alarm_options.lessequalThan')}</Option>
        <Option value="==">{t('views.dynamic_alarms_create_edit.type_alarm_options.equalThan')}</Option>

      </Select>

      <div className={`${styles.take_two_columns} ${styles.input_threshold}`}>
          {
            type === 'numeric_threshold' && (
              <InputNumber
                step={1}  
                value={params.value}
                onChange={(value) => { 
                  
                  if(`${value}`.match(ExpRegSoloNumeros)!=null){
                    onChangeOrCondition('value', value)
                  }else if(`${value}` ==''){
                    onChangeOrCondition('value', '')
                  }

                }}
                disabled={isEditDefault}
              />
            )
          }

          {
            type === 'time_threshold' && (
              <TimePicker 
                value={params.value ? moment(params.value, format) : null}
                onChange={(value) => {
                  if (value !== null) {
                    onChangeOrCondition('value', moment(value).format(format));
                  } else {
                    onChangeOrCondition('value', '');
                  }
                }}
                format={format}
                disabled={isEditDefault}
              />
            )
          }
          <Paragraph strong>{' '}</Paragraph>
      </div>
    </>
  );

}

ThresholdInputValue.propTypes = {
  params: PropTypes.objectOf(PropTypes.any).isRequired,
  onChangeOrCondition: PropTypes.func.isRequired,
  fieldSelected: PropTypes.objectOf(PropTypes.any),
};

ThresholdInputValue.defaultProps = {
  fieldSelected: null,
};

export default ThresholdInputValue;
